import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		phoneReg: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
		emailReg: /^([0-9A-Za-z\-_\.]+)@([0-9A-Za-z\-_\.]+\.[a-z]{2,3}(\.[a-z]{2})?)$/
	},
	mutations: {},
	actions: {},
	modules: {}
});
